var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class NumericRangeSlide extends Component {
  static getDerivedStateFromProps({ value }) {
    if (value) {
      return { value };
    }

    return null;
  }

  constructor(props) {
    super(props);
    this.state = { value: props.value };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const { value } = e.target;
    this.setState({ value });
    const { delay, onChange } = this.props;
    if (delay) {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        onChange(value ? parseFloat(value) : null);
      }, delay);

      return;
    }

    onChange(value ? parseFloat(value) : null);
  }

  renderTickMarksDatalist() {
    const { min, max, step, prefix } = this.props;
    return /*#__PURE__*/(
      _jsx("datalist", { id: `${prefix}-tickmarks` }, void 0, /*#__PURE__*/
      _jsx("option", { value: min }),
      (() => {
        const options = [];
        for (let i = min; i < max; i += step) {
          options.push( /*#__PURE__*/_jsx("option", { value: i.toFixed(2) }, i));
        }
        return options;
      })(), /*#__PURE__*/
      _jsx("option", { value: max })
      ));

  }

  render() {
    const { min, max, step, prefix, minLabel, maxLabel } = this.props;
    const { value } = this.state;
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "NumericRangeSlide" }, void 0, /*#__PURE__*/
      _jsx("input", {
        type: "range",
        list: `${prefix}-tickmarks`,
        min: min,
        max: max,
        step: step,
        onChange: this.onChange,
        value: value }
      ), /*#__PURE__*/
      _jsx("div", { className: "NumericRangeSlide-range-labels" }, void 0, /*#__PURE__*/
      _jsx("span", {}, void 0, minLabel), /*#__PURE__*/
      _jsx("span", {}, void 0, maxLabel)
      )
      ),
      this.renderTickMarksDatalist()
      ));

  }
}

NumericRangeSlide.defaultProps = {
  onChange: () => {},
  value: 50,
  step: 5,
  min: 0,
  max: 100,
  prefix: '',
  delay: 0,
  minLabel: '',
  maxLabel: ''
};